import { render, staticRenderFns } from "./CarouselPagination.vue?vue&type=template&id=57faa1e6&"
import script from "./CarouselPagination.vue?vue&type=script&lang=js&"
export * from "./CarouselPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports